<div class="interaction-bar-wrapper share-file-wrapper">
  <div class="interaction-bar-title text-capitalize">Share {{ itemType ?? 'document' }}</div>

  @if (!isLoading) {
    <div class="interaction-bar-content">
      @if (itemType) {
        <div class="name-wrapper section">
          <div class="text-uppercase label">{{ itemType }} name</div>
          <div class="item-name">{{ item?.name }}</div>
        </div>
      }
      <ng-scrollbar class="std-scrollbar flex-1" appearance="native" orientation="vertical">
        @if (!showEmailInput && accessibleUsers.length > 0) {
          <app-dropdown
            class="input"
            name="participantsControlModel"
            [(ngModel)]="participantsControlModel"
            [multiple]="true"
            [options]="accessibleUsers"
            optionLabel="name"
            optionValue="id"
            label="Select who to share with"
            placeholder="Select who to share with"
            required
          >
            <ng-template #selectedContent #optionContent let-option>
              @if (option.id) {
                <div>{{ option.name ?? option.email }}</div>
              }
              @if (!option.id) {
                <span class="custom-mat-option" (click)="addManualEmailInput()">
                  <span class="icon-add-round"></span>
                  <span>Manually Input Email</span>
                </span>
              }
            </ng-template>
          </app-dropdown>
        }
        @if (showEmailInput || accessibleUsers?.length === 0) {
          <div class="section">
            <app-floating-input
              formControlName="emailControl"
              (focusout)="addEmailToSelectOptions()"
              (keyup.enter)="addEmailToSelectOptions()"
              [formControl]="emailControl"
              iconClass="icon icon-remove"
              (iconClick)="addManualEmailInput()"
              ngDefaultControl
              type="email"
              placeholder="Select who to share with (email)"
              label="Select who to share with (email)"
            ></app-floating-input>
          </div>
        }
        <app-dropdown
          class="input"
          name="selectedRight"
          [options]="selectableRights"
          [(ngModel)]="selectedRight"
          label="Share Rights"
          placeholder="Share Rights"
        >
        </app-dropdown>
        <div class="accessors section">
          <div class="label text-uppercase">current access</div>
          @if (currentAccessors.length === 0) {
            <div>No users with access.</div>
          }
          @for (accessor of currentAccessors; track accessor) {
            <div class="accessor-wrapper" [ngClass]="accessor.is_bundle ? 'email' : ''">
              <div class="accessor">
                <div class="accessor-info">
                  <app-faded-text class="accessor-name user">{{ accessor?.name }}</app-faded-text>
                  <app-faded-text class="accessor-name">{{
                    accessor?.file?.name ?? accessor?.folder?.name
                  }}</app-faded-text>
                </div>
                <span
                  [ngClass]="{
                    'access-read-only': accessor.permissions === 'read',
                    'access-read-upload': accessor.permissions === 'edit'
                  }"
                  class="accessor-permission"
                  >{{ accessor.permissions === 'read' || accessor.is_bundle ? '(R)' : '(R & U)' }}</span
                >
                <span class="flex items-end">
                  <span (click)="removeAccessor(accessor)" class="button"> Remove </span>
                </span>
              </div>
              @if (accessor.is_bundle) {
                <div (click)="copyEmailLink(accessor)" class="copy-link">copy link</div>
              }
            </div>
          }
        </div>
      </ng-scrollbar>
      <button [disabled]="showEmailInput" (click)="share()" class="btn-save" mat-button>Share</button>
    </div>
  }
  @if (isLoading) {
    <div class="notify-msg animate-pulsating-border">
      <div class="icon-logo-box-hex"></div>
    </div>
  }
</div>
